import { isEmpty, round } from "lodash-es";
import type { TFunction } from "i18next";
import { getTimeZones } from "@vvo/tzdb";
import type { DateFormat } from "../state/customer";

export const TIMEZONES = getTimeZones({ includeUtc: true });
export const TIMEZONE_OPTIONS = TIMEZONES.map(({ currentTimeFormat, name }) => ({
  value: name,
  label: currentTimeFormat,
  variant: "text" as const,
}));

export const seconds = (sec: number): number => sec * 1000;

export const minutes = (min: number): number => min * seconds(60);

export const hours = (hrs: number): number => hrs * minutes(60);

export const formatDuration = (inputHours: number, t: TFunction): string => {
  const milliseconds = round(inputHours * 60 * 60 * 1000, 0);
  const absMilliseconds = Math.abs(milliseconds);
  const minutes = Math.round((absMilliseconds / 6e4) % 60);
  const hours = Math.floor((absMilliseconds / 36e5) % 24);
  const days = Math.floor(absMilliseconds / 864e5);

  const array = [];
  if (days > 0) {
    array.push(days + t(($) => $.DAY_ABBREVIATION));
  }
  if (hours > 0) {
    array.push(hours + t(($) => $.HOUR_ABBREVIATION));
  }
  if (minutes > 0) {
    array.push(minutes + t(($) => $.MINUTE_ABBREVIATION));
  }
  return (
    round(milliseconds / 36e5, 2) + t(($) => $.HOUR_ABBREVIATION) + (isEmpty(array) ? "" : ` (${array.join(" ")})`)
  );
};

const EXCEL_DATE_PATTERNS: Record<DateFormat, string> = {
  DDMMYYYY: "dd-mm-yyyy",
  MMDDYYYY: "mm-dd-yyyy",
  YYYYMMDD: "yyyy-mm-dd",
};

export const toExcelDatePattern = (dateFormat: DateFormat): string => EXCEL_DATE_PATTERNS[dateFormat];
